module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "flexContainers",
    attrs: {
      "id": "modal"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "flexContainer abs",
    attrs: {
      "id": "spinnerLoader"
    }
  }, [_c('Spinner', {
    staticClass: "loader",
    attrs: {
      "animation-duration": 5000,
      "size": 60,
      "color": '#41b4e8'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getBook.hasOwnProperty('vide') === false) ? _c('div', {
    staticClass: "wishlist"
  }, [_c('header', {
    staticClass: "wishlist-header"
  }, [_c('i', {
    staticClass: "icon-close",
    on: {
      "click": function($event) {
        _vm.closeModal();
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modalBody"
  }, [(Object.keys(this.getBook.data).length > 0) ? _c('div', {
    key: "brand"
  }, [_c('div', [_c('div', [_c('div', {
    staticClass: "modalBody"
  }, [_c('div', {
    staticClass: "modalContent"
  }, [_c('h1', {
    staticClass: "listTitle titleName"
  }, [_vm._v(_vm._s(_vm.getBook.name))]), _vm._v(" "), (_vm.avtivIconeMod === false) ? _c('img', {
    staticClass: "pointer fright icone",
    attrs: {
      "src": require("../../../static/assets/mod-icon.svg"),
      "alt": "",
      "height": "25",
      "width": "25"
    },
    on: {
      "mouseover": function($event) {
        _vm.avtivIconeMod = true;
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.avtivIconeMod === true) ? _c('img', {
    staticClass: "pointer fright icone",
    attrs: {
      "src": require("../../../static/assets/mod-icon-red.svg"),
      "alt": "",
      "height": "25",
      "width": "25"
    },
    on: {
      "mouseleave": function($event) {
        _vm.avtivIconeMod = false;
      },
      "click": function($event) {
        _vm.updateList();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.avtivIconeDel === false) ? _c('img', {
    staticClass: "pointer fright icone",
    attrs: {
      "src": require("../../../static/assets/delete-icon.svg"),
      "alt": "",
      "height": "25",
      "width": "25"
    },
    on: {
      "mouseover": function($event) {
        _vm.avtivIconeDel = true;
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.avtivIconeDel === true) ? _c('img', {
    staticClass: "pointer fright icone",
    attrs: {
      "src": require("../../../static/assets/delete-icon-red.svg"),
      "alt": "",
      "height": "25",
      "width": "25"
    },
    on: {
      "mouseleave": function($event) {
        _vm.avtivIconeDel = false;
      },
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.deleteList(_vm.getBook);
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.avtivIconeDow === false) ? _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showIconDow),
      expression: "showIconDow"
    }],
    staticClass: "pointer fright icone",
    attrs: {
      "src": require("../../../static/assets/download.svg"),
      "alt": "",
      "height": "25",
      "width": "25"
    },
    on: {
      "mouseover": function($event) {
        _vm.avtivIconeDow = true;
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.avtivIconeDow === true) ? _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showIconDow),
      expression: "showIconDow"
    }],
    staticClass: "pointer fright icone",
    attrs: {
      "src": require("../../../static/assets/download-red.svg"),
      "alt": "",
      "height": "25",
      "width": "25"
    },
    on: {
      "mouseleave": function($event) {
        _vm.avtivIconeDow = false;
      },
      "click": function($event) {
        _vm.exportPdf(_vm.getBook);
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editName) ? _c('div', {
    staticClass: "wishlist-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getBook.name),
      expression: "getBook.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.getBook.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.getBook.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.saveUpdate();
      }
    }
  }, [_vm._v("OK")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getBook.data.components), function(n, index) {
    return _c('div', {
      key: index,
      staticClass: "flexContainer ai-c jc-sb listComponent"
    }, [_c('span', {
      staticClass: "componentName"
    }, [_vm._v(_vm._s(n.name[_vm.$t("trad")]["value"]) + "   " + _vm._s(n.type.name ? "[ " + n.type.name + " ]" : ""))]), _vm._v(" "), _c('img', {
      staticClass: "trashBean pointer fright",
      attrs: {
        "src": require("../../../static/assets/delete-icon.svg"),
        "width": "20",
        "height": "20",
        "alt": ""
      },
      on: {
        "click": function($event) {
          _vm.deleteComponent(_vm.getBook, n);
        }
      }
    })])
  })], 2)])])])]) : _vm._e(), _vm._v(" "), (Object.keys(this.getBook.data).length === 0) ? _c('div', {
    key: "brand"
  }, [_c('div', [_c('div', [_c('div', {
    staticClass: "modalBody"
  }, [_c('div', {
    staticClass: "modalContent"
  }, [(_vm.getBook.hasOwnProperty('vide')) ? _c('h1', {
    staticClass: "listTitle titleName"
  }, [_vm._v(_vm._s(_vm.getBook.vide))]) : _c('h1', {
    staticClass: "listTitle titleName"
  }, [_vm._v(_vm._s(_vm.getBook.name))]), _vm._v(" "), _c('div', {
    staticClass: "flexContainer ai-c jc-sb listComponent"
  }, [_c('span', {
    staticClass: "componentNameVide center bold"
  }, [_vm._v("BOOK VIDE " + _vm._s(_vm.getBook.length))])])]), _vm._v(" "), _c('br')])])])]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38d266d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/wishlist/modalBook.vue
// module id = 3125
// module chunks = 0